<template>
  <div class="hm-card landing blue-header-banner">
    <div class="header-banner">
      <h2>What is Your Income?</h2>
      <p>Include total compensation from retirement benefits
        and work income that you and/or your spouse receive.</p>
    </div>
    <div class="max-w white text-center">
      <div class="income-card-holder" style="display: flex; margin-top: 2em; text-align: initial;">
        <div class="income-card">
            <CheckSelectInput
              label="Do you receive monthly checks for retirement benefits such as Social Security, pensions, or annuities?"
              tooltip="This is the amount you collect each month. It includes Social Security, pension, annuities, workers' compensation, rental income, and other retirement benefits."
              image-name="Capitol.svg"
              yes="Yes, I do."
              no="No, I do not."
              v-model="hasMonthlyChecks"
            />
          <br>
          <div class="text-center" v-if="hasMonthlyChecks">
            <p style="margin-top:1em;">How much do you receive monthly?</p>
            <SuiInput
              v-if="hasMonthlyChecks"
              icon="dollar sign"
              icon-position="left"
              type="number"
              step=".01"
              min="0"
              v-model="$store.getters['getData']().houseHoldIncome.monthlyChecks"
              @input="onMonthlyChecksInput"
            />
          </div>
        </div>
        <div class="income-card">
          <CheckSelectInput
            label="In 2020, did you receive income for working?"
            tooltip="Earned income is the amount you earn from working each month/year. This amount includes any wages collected and any net earnings from self-employment."
            image-name="paycheck.svg"
            yes="Yes, I work and receive a paycheck."
            no="No, I do not work."
            v-model="hasWorkingIncome"
          />
          <br>
          <div class="text-center" v-if="hasWorkingIncome">
            <p style="margin-top:1em;">How much do you receive annually?</p>
            <SuiInput
              icon="dollar sign"
              icon-position="left"
              type="number"
              step=".01"
              min="0"
              v-model="$store.getters['getData']().houseHoldIncome.workingIncome"
              @input="onWorkingIncomeInput"
            />
          </div>
        </div>
      </div>

      <SuiButton
        class="next-btn"
        color="green"
        content="Next"
        :disabled="isNextDisabled()"
        @click="() => goNextStep('people-in-household')"
      />
    </div>
  </div>
</template>

<script>
  import HouseholdIncome from '@/components/small/HouseholdIncome';

  export default {
    extends: HouseholdIncome,
  }
</script>
